import { apolloClient } from '~/apollo-client';
import type {
  EmailEventInput,
  SendEmailsMutationVariables,
  SendEmailsMutation,
} from '~/typings/graphql';
import { errors } from '~/utils/error-messages';
import { trackError } from '~/utils/tracking';
import { SEND_EMAILS } from './send-telesales-email.queries';

export interface SendTelesalesEmailParams {
  salesPhase:
    | 'needs-utility-information'
    | 'needs-payment-information'
    | 'needs-terms-and-conditions';
  userId: number;
  enrollmentOption?: string;
}

export interface SendTelesalesEmailInput {
  salesPhase: string;
  userId: number;
}

export interface SendTelesalesEmailServiceResponse {
  totalFailed: number;
  totalSent: number;
  errorMessage?: string;
}

export const sendTelesalesEmail = async (
  params: SendTelesalesEmailParams,
): Promise<SendTelesalesEmailServiceResponse> => {
  const { userId, salesPhase, enrollmentOption } = params;

  if (!userId) {
    trackError(new Error(errors.missingTelesalesUserId));
    throw new Error(errors.missingTelesalesUserId);
  }

  let emailName;
  if (salesPhase === 'needs-payment-information') {
    emailName = 'telesales-resume-payment';
  } else if (salesPhase === 'needs-utility-information') {
    emailName = 'telesales-resume-utility';
  } else if (salesPhase === 'needs-terms-and-conditions') {
    emailName = 'telesales-resume-terms';
  }

  const input: EmailEventInput = {
    name: emailName,
    data: {
      userId,
      enrollmentOption,
    },
  };

  try {
    const response = await apolloClient.mutate<SendEmailsMutation, SendEmailsMutationVariables>({
      mutation: SEND_EMAILS,
      variables: { inputs: [input] },
    });

    const { totalSent = 0, totalFailed = 0 } = response.data?.sendEmailEvents || {};
    return { totalFailed, totalSent };
  } catch (error) {
    const errorMessage = error.message.includes('not authorized')
      ? 'Please check the user details and try again.'
      : error.message;
    return { totalFailed: 1, totalSent: 0, errorMessage };
  }
};
